<script lang="ts">
	import { _ } from "svelte-i18n";

	let {
		onRetry,
		onRestart,
	}: {
		onRetry?: () => void;
		onRestart?: () => void;
	} = $props();
</script>

<div class="wrapper">
	{$_("landingpage.newPresentation.generationFailed")}<br />
	<div class="error">{$_("landingpage.newPresentation.generationFailedTechnicalError")}</div>
	<button onclick={() => onRetry?.()}
		>{$_("landingpage.newPresentation.retryWithSamePrompt")}</button
	>
	<button onclick={() => onRestart?.()}
		>{$_("landingpage.newPresentation.retryWithDifferentPrompt")}</button
	>
</div>

<style>
	.wrapper {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: 0.5rem;
	}
	.error {
		color: red;
		font-weight: bold;
	}
</style>
